import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withClasses } from "@xo-union/react-css-modules";
import uniqueID from "@xo-union/react-unique-id";
import classesPropType from "@xo-union/classes-prop-type";
import { labelize } from "../../utilities/index.js";
import Input from "../Input/index.js";
import styles from "./styles.css";

var Field =
/*#__PURE__*/
function (_Component) {
  _inherits(Field, _Component);

  function Field() {
    _classCallCheck(this, Field);

    return _possibleConstructorReturn(this, _getPrototypeOf(Field).apply(this, arguments));
  }

  _createClass(Field, [{
    key: "render",
    value: function render() {
      var _context, _context2;

      var _this$props = this.props,
          name = _this$props.name,
          subText = _this$props.subText,
          type = _this$props.type,
          state = _this$props.state,
          classes = _this$props.classes,
          _this$props$label = _this$props.label,
          label = _this$props$label === void 0 ? labelize(name) : _this$props$label,
          id = _this$props.id,
          ariaDescribedByIds = _this$props['aria-describedby'],
          props = _objectWithoutProperties(_this$props, ["name", "subText", "type", "state", "classes", "label", "id", "aria-describedby"]);

      var validationClassMap = {
        neutral: classes['is-neutral'],
        invalid: classes['is-invalid'],
        valid: classes['is-valid']
      };
      var validationClass = validationClassMap[state];
      var subtextId;

      if (subText) {
        subtextId = "".concat(id, "-subtext");
      }

      var ariaDescribedBy = _filterInstanceProperty(_context = [ariaDescribedByIds, subtextId]).call(_context, Boolean).join(' ') || null;
      return React.createElement("div", {
        className: classes.container
      }, React.createElement(Input, _extends({
        type: type,
        className: _concatInstanceProperty(_context2 = "".concat(classes.input, " ")).call(_context2, validationClass),
        id: id,
        name: name,
        placeholder: " ",
        "aria-describedby": ariaDescribedBy
      }, props)), React.createElement("label", {
        className: classes.label,
        htmlFor: id
      }, label), subText && React.createElement("div", {
        className: classes['sub-text'],
        id: subtextId
      }, subText));
    }
  }]);

  return Field;
}(Component);

_defineProperty(Field, "defaultProps", {
  state: 'neutral',
  type: 'text'
});

process.env.NODE_ENV !== "production" ? Field.propTypes = {
  /**
   * Name used for input element
   */
  name: PropTypes.string.isRequired,

  /**
   * The input's label string. If not provided, it is assumed from the name.
   */
  label: PropTypes.string,

  /**
   * Force the visual state
   */
  state: PropTypes.oneOf(['neutral', 'valid', 'invalid']),

  /**
   * Subtext message used to provide the user with extra information. The subText will appear just below the field.
   */
  subText: PropTypes.string,

  /**
   * The input's initial aria-describedby value. This will be appended to based on the subText value.
   */
  'aria-describedby': PropTypes.string,

  /**
   * The input type
   */
  type: PropTypes.string,

  /**
   * The input's id. If not provided, it is assumed from the name.
   */
  id: PropTypes.string,

  /**
   * Classes dependencies
   */
  classes: classesPropType(['container', 'input', 'is-valid', 'is-invalid', 'label', 'sub-text']),

  /**
   * Pass ref to input to control things such as focus using React 15.x refs API. Doc:
   * https://react-legacy.netlify.com/docs/refs-and-the-dom.html
   */
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape()
  })]),

  /**
   * Called when the `value` content attribute is added, set, or removed
   */
  onChange: PropTypes.func,

  /**
   * Current value of the `input` element. In the React rendering lifecycle, the `value` attribute on form elements will override the value in the DOM.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),

  /**
   * Reflects the default value of the `input` field. Use this if you want React to specify the initial value but leave subsequent updates uncontrolled.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
} : void 0;
export default withClasses(styles)(uniqueID(['id'])(Field));